/**
 * Coerces the stored Yes/No form default into a boolean for the Formik initial value.
 * Empty / null / undefined → undefined (no default applied).
 */
export const normalizeYesNoDefaultValue = (value: unknown): boolean | undefined => {
  if (value === "" || value == null) {
    return undefined;
  }
  if (typeof value === "boolean") {
    return value;
  }
  if (typeof value === "string" || typeof value === "number") {
    return ["yes", "true", "1"].includes(String(value).toLowerCase());
  }
  return false;
};
